module.exports = __webpack_public_path__ + "img/mt4Bg.bef6cbce.png";